<template>
  <div class="px-8 pt-4 pb-2" :class="{ isEditing }">
    <v-row>
      <v-col cols="12" md="4">
        <text-field
          label="Rent/Mortgage/Lot Rent"
          v-model="expenses.rentMortgage"
          :rules="[validators.required, validators.name]"
          maxlength="100"
          :readonly="readonly"
        />
      </v-col>
      <v-col cols="12" md="4">
        <text-field
          label="Food (not including food stamps)"
          v-model="expenses.food"
          :rules="[validators.required, validators.name]"
          maxlength="100"
          :readonly="readonly"
        />
      </v-col>
      <v-col cols="12" md="4">
        <text-field
          label="Car Payment"
          v-model="expenses.carPayment"
          :rules="[validators.name]"
          maxlength="100"
          :readonly="readonly"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="4">
        <text-field
          label="Car Insurance"
          v-model="expenses.carInsurance"
          :rules="[validators.required, validators.name]"
          maxlength="100"
          :readonly="readonly"
        />
      </v-col>
      <v-col cols="12" md="4">
        <text-field
          label="Transportation Expense"
          v-model="expenses.transport"
          :rules="[validators.required, validators.name]"
          maxlength="100"
          :readonly="readonly"
        />
      </v-col>
      <v-col cols="12" md="4">
        <text-field
          label="Childcare"
          v-model="expenses.childCare"
          :rules="[validators.name]"
          maxlength="100"
          :readonly="readonly"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="4">
        <text-field
          label="Cable"
          v-model="expenses.cable"
          :rules="[validators.required, validators.name]"
          maxlength="100"
          :readonly="readonly"
        />
      </v-col>
      <v-col cols="12" md="4">
        <text-field
          label="Child Support"
          v-model="expenses.childSupport"
          :rules="[validators.required, validators.name]"
          maxlength="100"
          :readonly="readonly"
        />
      </v-col>
      <v-col cols="12" md="4">
        <text-field
          label="Internet"
          v-model="expenses.internet"
          :rules="[validators.name]"
          maxlength="100"
          :readonly="readonly"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="4">
        <text-field
          label="Diapers"
          v-model="expenses.diapers"
          :rules="[validators.required, validators.name]"
          maxlength="100"
          :readonly="readonly"
        />
      </v-col>
      <v-col cols="12" md="4">
        <text-field
          label="Water"
          v-model="expenses.water"
          :rules="[validators.required, validators.name]"
          maxlength="100"
          :readonly="readonly"
        />
      </v-col>      
    </v-row>
    <v-row>
      <v-col cols="12" md="4">
        <text-field
          label="Electricity"
          v-model="expenses.electricity"
          :rules="[validators.required, validators.name]"
          maxlength="100"
          :readonly="readonly"
        />
      </v-col>
      <v-col cols="12" md="4">
        <text-field
          label="Gas"
          v-model="expenses.gas"
          :rules="[validators.required, validators.name]"
          maxlength="100"
          :readonly="readonly"
        />
      </v-col>
      <v-col cols="12" md="4">
        <text-field
          label="Telephones"
          v-model="expenses.telephone"
          :rules="[validators.name]"
          maxlength="100"
          :readonly="readonly"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="4">
        <text-field
          label="Laundry"
          v-model="expenses.laundry"
          :rules="[validators.required, validators.name]"
          maxlength="100"
          :readonly="readonly"
        />
      </v-col>
      <v-col cols="12" md="4">
        <text-field
          label="Household Items"
          v-model="expenses.houseHoldItems"
          :rules="[validators.required, validators.name]"
          maxlength="100"
          :readonly="readonly"
        />
      </v-col>  
      <v-col cols="12" md="4">
        <text-field
          label="Total Montly Expenses"
          v-model="expenses.total"
          :rules="[validators.name]"
          maxlength="100"
          :readonly="readonly"
        />
      </v-col>    
    </v-row>
    <v-row>
      <v-col cols="12" md="4">
        <text-field
          label="Are there any other expenses you would like us to consider, if so, please describe them here:"
          v-model="expenses.otherKnownExpenses"
          :rules="[validators.required, validators.name]"
          maxlength="100"
          :readonly="readonly"
        />
      </v-col>      
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import formatters from '@/helpers/formatters'
import validators from '@/helpers/validators'
import { findValidatableElement } from '@/helpers/form'

import TextField from '@/components/form/TextField'
import SelectField from '@/components/form/SelectField'
import AdsFormatContactField from '@/components/app/AdsFormatContactField'
import MultiSelectField from '@/components/form/MultiSelectField'
import DateField from '@/components/form/DateField'
import ReadOnlyField from '@/components/form/ReadOnlyField'
import RadioOptions from '@/components/form/RadioOptions'
import { GENDER_OPTIONS,DATE_OF_BIRTH_MINIMUM_YEAR } from '@/constants'

function dateToIsoDate(date) {
  return date.toISOString ? date.toISOString().slice(0, 10) : null
}

export default {
  name: 'ExpenseDetails',
  components: {
    TextField,
    SelectField,
    MultiSelectField,
    DateField,
    ReadOnlyField,
    RadioOptions,
    AdsFormatContactField
  },
  props: {
    readonly: {
      type: Boolean,
      defaiult: true
    }
  },
  data() {
    const sevenDaysAgo = new Date()
    sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7)

    const startOfThisYear = new Date()
    startOfThisYear.setDate(1)
    startOfThisYear.setMonth(0)

    const endOfNextYear = new Date()
    endOfNextYear.setMonth(11, 31) // zero based months!
    endOfNextYear.setFullYear(startOfThisYear.getFullYear() + 1)

    const thisYear = new Date().getFullYear()
    const minAttendedYear = thisYear -16
    const maxAttendedLastDate = `${thisYear.toString()}-12-31`

    const {
      required,
      noPastDate,
      noFutureDate,
      noFutureMonthAndYear,
      noMonthAndYearBefore16years,
      name,
      primaryClientMaxAge
    } = validators

    return {
      MONTH_YEAR_DATE_FORMAT: 'MM-YYYY',
      minBirthDate: `${thisYear - DATE_OF_BIRTH_MINIMUM_YEAR}-01-01`,
      sevenDaysAgo: dateToIsoDate(sevenDaysAgo),
      endOfNextYear: dateToIsoDate(endOfNextYear),
      boolYesNo: formatters.boolYesNo,
      validators: {
        required,
        noPastDate,
        noFutureDate,
        noFutureMonthAndYear,
        noMonthAndYearBefore16years,
        name,
        primaryClientMaxAge,
        maxStartDate: validators.getMaxFutureYearValidator(1),
        prevSchoolEndDate: toDate =>
          validators.dateOrder(
            this.previousSchool.prevSchoolStartDate,
            toDate
          ) || "Cannot be earlier than 'Attended from' date"
      },
      genderOptions: GENDER_OPTIONS,
      minAttendedStartDate: new Date(`${minAttendedYear}-01-01`).toISOString().slice(0, 10),
      maxAttendedStartDate: new Date().toISOString().slice(0, 10),
      maxAttendedLastDate
    }
  },
  computed: {
    ...mapGetters([
      'application', 
      'isEditing', 
      'referenceData'
    ]),
    expenses() {
      return this.application.application.expenses
    }
  },
  methods: {
   
  }
}
</script>
